import React from "react";
import "./services.css";
import { GoArrowRight } from "react-icons/go";
export default function Service() {
    return (
        <div id="Services" className="services">
            <div className="servicesTitle">
                <h1>My services</h1>
                <img src="/images/back.png" alt="" />
            </div>
            <div className="serviceCont">
                <div className="serviceFormat">
                    <h3>01</h3>
                    <h2>web development</h2>
                    <p>I'm passionate about Web Development, specializing in crafting responsive, user-friendly interfaces and building robust back-end systems. I enjoy bringing ideas to life on the web with clean, efficient, and scalable code.</p>
                    <div className="serviceReadMore">
                        <p>Read More</p>
                        <GoArrowRight/>
                    </div>
                </div>
                <div className="serviceFormat">
                    <h3>02</h3>
                    <h2>Database managment</h2>
                    <p>I'm skilled in Database Management, ensuring data is structured, secure, and easily accessible. I specialize in designing, optimizing, and maintaining databases to support seamless application performance</p>
                    <div className="serviceReadMore">
                        <p>Read More</p>
                        <GoArrowRight/>
                    </div>
                </div>
                <div className="serviceFormat">
                    <h3>03</h3>
                    <h2>Frontend</h2>
                    <p>I'm a Front-End Developer focused on creating intuitive and visually appealing user interfaces. I love turning ideas into responsive, interactive designs that enhance user experience across devices.</p>
                    <div className="serviceReadMore">
                        <p>Read More</p>
                        <GoArrowRight/>
                    </div>
                </div>
                <div className="serviceFormat">
                    <h3>04</h3>
                    <h2>Backend</h2>
                    <p>I'm a Back-End Developer specializing in building efficient server-side logic and APIs. I focus on creating secure, scalable systems that power seamless communication between databases and front-end applications</p>
                    <div className="serviceReadMore">
                        <p>Read More</p>
                        <GoArrowRight/>
                    </div>
                </div>
            </div>
        </div>
    )
}